import React from 'react';

const DoneIcon = () => (
  <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 0.5L4.25 8.75L0.5 5" stroke="#333333" />
  </svg>
);

export default DoneIcon;
